import { RouterState } from './router.type';

export const ROUTE_URL = 'ROUTE_URL';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export interface RouteURLAction {
  type: typeof ROUTE_URL;
  payload: RouterState;
}

export interface ChangeLocationAction {
  type: typeof CHANGE_LOCALE;
  locale: string;
}

export type RouterActionTypes = RouteURLAction | ChangeLocationAction;

export type RouterActions = RouterActionTypes;
